import { combineReducers } from "redux";
import LoginSlice from "./slice/loginSlice";
import SportsSlice from "./slice/sportsSlice";
import CourtsSlice from "./slice/courtsSlice";
import UsersSlice from "./slice/usersSlice";
import TransactionsSlice from "./slice/transactionsSlice";
import RevenueSlice from "./slice/revenueSlice";
import NotificationsSlice from "./slice/notificationSlice";
import GamesSlice from "./slice/gamesSlice";
import ConfigSlice from "./slice/configSlice"

const appReducer = combineReducers({
  login: LoginSlice,
  sports: SportsSlice,
  courts: CourtsSlice,
  users: UsersSlice,
  transactions: TransactionsSlice,
  revenue: RevenueSlice,
  notifications: NotificationsSlice,
  games: GamesSlice,
  config: ConfigSlice
});

export const logout = () => ({ type: "LOGOUT" });

const RootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default RootReducer;